import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const LoadingSpinnerIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 32 32",
    },
    <path
      stroke="currentColor"
      strokeWidth={4}
      d="M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2"
    />
  );
